/* eslint-disable @typescript-eslint/no-explicit-any */

import * as React from "react"
import { Modal } from "react-overlays"
import Transition from "react-transition-group/Transition"

import { bem } from "../../bem"
const b = bem.with("NewUI__backdrop")

import "./Backdrop.scss"

const TRANSITION_DURATION = 300

const transitionStyles: Record<string, string> = {
    entering: "NewUI__in",
    entered: "NewUI__in",
    exiting: "",
    exited: "",
}

const Animation: any = ({ children, ...attrs }: any) => (
    <Transition {...attrs} timeout={TRANSITION_DURATION}>
        {(
            status: string,
            innerProps: any,
        ): React.DetailedReactHTMLElement<any, HTMLElement> =>
            React.cloneElement(children, {
                ...innerProps,
                className: `NewUI__animation ${transitionStyles[status]} ${
                    children.props.className
                } ${b()}`,
            })
        }
    </Transition>
)

interface Props extends React.HTMLAttributes<HTMLElement> {
    onHide: () => void
    show: boolean
    children?: React.ReactElement
}

export const Backdrop = ({ children, ...attrs }: Props): JSX.Element => (
    <Modal backdropTransition={Animation} transition={Animation} {...attrs}>
        {children}
    </Modal>
)

export default Backdrop
